import { FunctionComponent } from 'react'
import { UpdateModal as UpdateModalComponent } from 'components/UpdateModal/UpdateModal'
import { AiAvatarAnnouncementModal } from 'components/AiAvatarAnnouncementModal/AiAvatarAnnouncementModal'
import { UpdateModal as UpdateModalType } from 'hooks/queries/updateModals/useUpdateModals'

type AnnouncementComponent = FunctionComponent<{ updateModal: UpdateModalType }>

const REGISTRY: Record<string, AnnouncementComponent> = {
  ai_avatar_videos: AiAvatarAnnouncementModal,
}

export const isBespokeAnnouncement = (modal: UpdateModalType): boolean =>
  !!modal.component_key && modal.component_key in REGISTRY

export const announcementComponentFor = (modal: UpdateModalType): AnnouncementComponent =>
  (modal.component_key && REGISTRY[modal.component_key]) || UpdateModalComponent
